import settingsPlugin from '../settingsPlugin';

import appIdAppCodeSettings from './appIdAppCodeSettings';
import apiKeySettings from './apiKeySettings';
import credentials from './credentials';
import platformCredentialSettings from './platformCredentialSettings';
import directSettings from './DirectSettings';

settingsPlugin.register('appIdAppCode', appIdAppCodeSettings);
settingsPlugin.register('apiKey', apiKeySettings);
settingsPlugin.register('credentials', credentials);
settingsPlugin.register('platformCredential', platformCredentialSettings);
settingsPlugin.register('direct', directSettings);
